<template>
	<TemplatePost title="Atualizar parceiro" @close="$router.back()" @post="completeRegister">
		<div>
			<FormFields @save="completeRegister" @update:values="inputsValues = $event" :fields="fields" />
		</div>
	</TemplatePost>
</template>

<script>
import TemplatePost from "../../../components/TemplatePost";
import FormFields from "../../../components/FormFields";
import { mapActions, mapMutations } from "vuex";
export default {
	name: "UpdatePartner",
	components: { FormFields, TemplatePost },
	data() {
		return {
			fields: [],
			inputsValues: {},
			empresas: []
		};
	},
	mounted() {
		this.SET_LOADING(true);
		window.fbq("trackCustom", "Edição de parceiro");
		if (this.$route.params.identificador) {
			this.action_buscar_empresas()
				.then((response) => {
					if (response) {
						this.empresas = response.data.dados.empresas;
					}
				})
				.catch(() => {
					this.SET_LOADING(false);
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Ocorreu um erro",
						message: `Empresas não encontradas`,
						styleMessage: "danger"
					});
				});
			this.action_buscar_parceiro({ id: this.$route.params.identificador }).then((response) => {
				if (response) {
					let parceiro = response.data.data;
					let header = parceiro.sessoes.find((sessao) => sessao.nome === "header");
					let about = parceiro.sessoes.find((sessao) => sessao.nome === "about");
					let partners = parceiro.sessoes.find((sessao) => sessao.nome === "partners");
					let contact = parceiro.sessoes.find((sessao) => sessao.nome === "contact");
					let tutorial = parceiro.sessoes.find((sessao) => sessao.nome === "tutorial");
					let logoForBackgroundWhite = parceiro.sessoes.find((sessao) => sessao.nome === "logoForBackgroundWhite");
					let customization = parceiro.sessoes.find((sessao) => sessao.nome === "customization");
					let omniChannel = parceiro.sessoes.find((sessao) => sessao.nome === "omniChannel");
					parceiro.sessoes = {
						header: header,
						about: about,
						partners: partners,
						contact: contact,
						tutorial: tutorial,
						logoForBackgroundWhite: logoForBackgroundWhite,
						customization: customization,
						omniChannel: omniChannel
					};

					this.fields = [
						{
							variableName: "nomeParceiro",
							fieldType: "TextField",
							label: "Nome do parceiro",
							type: "text",
							cols: "6",
							valueField: parceiro?.nome
						},
						{
							variableName: "subdominio",
							fieldType: "TextField",
							label: "Nome do subdomínio",
							type: "text",
							cols: "6",
							valueField: parceiro?.identificador
						},
						{
							variableName: "emp_codigo",
							fieldType: "SelectField",
							label: "Selecione a empresa parceira",
							options: this.empresas,
							keyName: "nome_empresa",
							keyValue: "codigo",
							type: "text",
							cols: "12",
							valueField: parceiro?.emp_codigo
						},
						{
							variableName: "hotjarId",
							fieldType: "TextField",
							label: "Hotjar ID",
							type: "text",
							cols: "12",
							valueField: parceiro?.hotjar_id
						},
						{
							variableName: "logo",
							fieldType: "ImageField",
							label: "Logotipo do parceiro",
							type: "text",
							cols: "3",
							valueField: parceiro?.logo
						},
						{
							variableName: "logoForBackgroundWhite",
							fieldType: "ImageField",
							label: "Logotipo para fundo branco",
							type: "text",
							cols: "3",
							valueField: parceiro?.sessoes?.logoForBackgroundWhite
						},
						{
							variableName: "corPrimaria",
							fieldType: "ColorField",
							label: "Cor primária",
							type: "text",
							cols: "3",
							valueField: parceiro?.estilo?.corPrimaria
						},
						{
							variableName: "corSecundaria",
							fieldType: "ColorField",
							label: "Cor secundária",
							type: "text",
							cols: "3",
							valueField: parceiro?.estilo?.corSecundaria
						},
						{
							fieldType: "HeaderLabel",
							label: "Cabeçalho"
						},
						{
							variableName: "imagemFundo",
							fieldType: "ImageField",
							label: "Imagem de fundo",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.header?.arquivos && parceiro?.sessoes?.header?.arquivos.length > 0 ? parceiro?.sessoes?.header?.arquivos[0].arquivo : undefined
						},
						{
							variableName: "tituloCabecalho",
							fieldType: "TextField",
							label: "Título do cabeçalho",
							type: "text",
							cols: "8",
							valueField: parceiro?.sessoes?.header?.campos?.title
						},
						{
							variableName: "subtituloCabecalho",
							fieldType: "TextField",
							label: "Subtítulo do cabeçalho",
							type: "text",
							cols: "8",
							valueField: parceiro?.sessoes?.header?.campos?.subtitle
						},
						{
							fieldType: "HeaderLabel",
							label: "Sobre"
						},
						{
							variableName: "tituloSobre",
							fieldType: "TextField",
							label: "Título",
							type: "text",
							cols: "8",
							valueField: parceiro?.sessoes?.about?.campos?.title
						},
						{
							variableName: "imagemSobre",
							fieldType: "ImageField",
							label: "Imagem da empresa",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.about?.arquivos && parceiro?.sessoes?.about?.arquivos.length > 0 ? parceiro?.sessoes?.about?.arquivos[0].arquivo : undefined
						},
						{
							variableName: "textoSobre",
							fieldType: "TextAreaField",
							label: "Texto",
							type: "text",
							cols: "12",
							valueField: parceiro?.sessoes?.about?.campos?.text
						},
						{
							fieldType: "HeaderLabel",
							label: "Passo a passo"
						},
						{
							variableName: "imagemTutorial",
							fieldType: "ImageField",
							label: "Imagem de fundo de passo a passo",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.tutorial?.arquivos && parceiro?.sessoes?.tutorial?.arquivos.length > 0 ? parceiro?.sessoes?.tutorial?.arquivos[0].arquivo : undefined
						},
						{
							variableName: "tituloTutorial",
							fieldType: "TextField",
							label: "Título passo a passo",
							type: "text",
							cols: "8",
							valueField: parceiro?.sessoes?.tutorial?.campos?.title
						},
						{
							variableName: "FirstTutorialTitle",
							fieldType: "TextField",
							label: "Título da 1ª etapa",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.tutorial?.campos?.steps && parceiro?.sessoes?.tutorial?.campos?.steps.length > 0 ? parceiro?.sessoes?.tutorial?.campos?.steps[0].title : undefined
						},
						{
							variableName: "FirstTutorialSubtitle",
							fieldType: "TextField",
							label: "Texto da 1ª etapa",
							type: "text",
							cols: "8",
							valueField: parceiro?.sessoes?.tutorial?.campos?.steps && parceiro?.sessoes?.tutorial?.campos?.steps.length > 0 ? parceiro?.sessoes?.tutorial?.campos?.steps[0].text : undefined
						},
						{
							variableName: "SecondTutorialTitle",
							fieldType: "TextField",
							label: "Título da 2ª etapa",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.tutorial?.campos?.steps && parceiro?.sessoes?.tutorial?.campos?.steps.length > 0 ? parceiro?.sessoes?.tutorial?.campos?.steps[1].title : undefined
						},
						{
							variableName: "SecondTutorialSubtitle",
							fieldType: "TextField",
							label: "Texto da 2ª etapa",
							type: "text",
							cols: "8",
							valueField: parceiro?.sessoes?.tutorial?.campos?.steps && parceiro?.sessoes?.tutorial?.campos?.steps.length > 0 ? parceiro?.sessoes?.tutorial?.campos?.steps[1].text : undefined
						},
						{
							variableName: "ThirdTutorialTitle",
							fieldType: "TextField",
							label: "Título da 3ª etapa",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.tutorial?.campos?.steps && parceiro?.sessoes?.tutorial?.campos?.steps.length > 0 ? parceiro?.sessoes?.tutorial?.campos?.steps[2].title : undefined
						},
						{
							variableName: "ThirdTutorialSubtitle",
							fieldType: "TextField",
							label: "Texto da 3ª etapa",
							type: "text",
							cols: "8",
							valueField: parceiro?.sessoes?.tutorial?.campos?.steps && parceiro?.sessoes?.tutorial?.campos?.steps.length > 0 ? parceiro?.sessoes?.tutorial?.campos?.steps[2].text : undefined
						},
						{
							variableName: "FourthTutorialTitle",
							fieldType: "TextField",
							label: "Título da 4ª etapa",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.tutorial?.campos?.steps && parceiro?.sessoes?.tutorial?.campos?.steps.length > 0 ? parceiro?.sessoes?.tutorial?.campos?.steps[3].title : undefined
						},
						{
							variableName: "FourthTutorialSubtitle",
							fieldType: "TextField",
							label: "Texto da 4ª etapa",
							type: "text",
							cols: "8",
							valueField: parceiro?.sessoes?.tutorial?.campos?.steps && parceiro?.sessoes?.tutorial?.campos?.steps.length > 0 ? parceiro?.sessoes?.tutorial?.campos?.steps[3].text : undefined
						},
						{
							fieldType: "HeaderLabel",
							label: "Parceiros"
						},
						{
							variableName: "textoParceiros",
							fieldType: "TextAreaField",
							label: "Texto parceiros",
							type: "text",
							cols: "12",
							valueField: parceiro?.sessoes?.partners?.campos?.text
						},
						{
							variableName: "logosParceiros",
							fieldType: "MultipleImagesField",
							label: "LogoTipo parceiro",
							type: "text",
							cols: "12",
							valueField: parceiro?.sessoes?.partners?.arquivos || []
						},
						{
							fieldType: "HeaderLabel",
							label: "Contato"
						},
						{
							variableName: "imagemFundoContato",
							fieldType: "ImageField",
							label: "Imagem de fundo contato",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.contact?.arquivos && parceiro?.sessoes?.contact?.arquivos.length > 0 ? parceiro?.sessoes?.contact?.arquivos[0].arquivo : undefined
						},
						{
							variableName: "endereco",
							fieldType: "TextField",
							label: "Endereço",
							type: "text",
							cols: "12",
							valueField: parceiro?.sessoes?.contact?.campos?.address
						},
						{
							variableName: "facebook",
							fieldType: "TextField",
							label: "Facebook (endereço completo)",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.contact?.campos?.url_facebook
						},
						{
							variableName: "instagram",
							fieldType: "TextField",
							label: "Instagram (endereço contato)",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.contact?.campos?.url_instagram
						},
						{
							variableName: "whatsapp",
							fieldType: "TextFieldMask",
							maskFormat: "(##) #####-####",
							label: "Whatsapp",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.contact?.campos?.whatsapp
						},
						{
							variableName: "telefone",
							fieldType: "TextFieldMask",
							maskFormat: "(##) ####-####",
							label: "Telefone",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.contact?.campos?.phone
						},
						{
							variableName: "phoneZeroEightHundred",
							fieldType: "TextFieldMask",
							maskFormat: "####-###-####",
							label: "Telefone 0800",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.contact?.campos?.phoneZeroEightHundred
						},
						{
							variableName: "email",
							fieldType: "TextField",
							label: "E-mail",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.contact?.campos?.email
						},
						{
							fieldType: "HeaderLabel",
							label: "Omni Channel"
						},
						{
							variableName: "whatsappOmni",
							fieldType: "TextFieldMask",
							maskFormat: "(##) #####-####",
							label: "Whatsapp",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.omniChannel?.campos?.whatsappOmni
						},
						{
							variableName: "instagramOmni",
							fieldType: "TextField",
							label: "Instagram (endereço completo)",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.omniChannel?.campos?.instagramOmni
						},
						{
							variableName: "telegram",
							fieldType: "TextField",
							label: "Telegram (inserir nome do usuário)",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.omniChannel?.campos?.telegram
						},
						{
							variableName: "messenger",
							fieldType: "TextField",
							label: "Messenger (inserir nome da página)",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.omniChannel?.campos?.messenger
						},
						{
							variableName: "usu_skype",
							fieldType: "TextField",
							label: "Skype (nome do usuário)",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.omniChannel?.campos?.usu_skype
						},
						{
							variableName: "linkedin",
							fieldType: "TextField",
							label: "Linked in (inserir link completo)",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.omniChannel?.campos?.linkedin
						},
						{
							variableName: "telefoneOmni",
							fieldType: "TextFieldMask",
							maskFormat: "(##) ####-####",
							label: "Telefone",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.omniChannel?.campos?.telefoneOmni
						},
						{
							variableName: "emailOmni",
							fieldType: "TextField",
							label: "E-mail",
							type: "text",
							cols: "4",
							valueField: parceiro?.sessoes?.omniChannel?.campos?.emailOmni
						},
						{
							fieldType: "HeaderLabel",
							label: "Customizações"
						},
						{
							variableName: "textAbaixoLogo",
							fieldType: "TextAreaField",
							label: "Texto do menu abaixo da logo",
							type: "text",
							cols: "12",
							valueField: parceiro?.sessoes?.customization?.campos?.menuDebits && parceiro?.sessoes?.customization?.campos?.menuDebits?.textAbaixoLogo ? parceiro?.sessoes?.customization?.campos?.menuDebits?.textAbaixoLogo : "Negocie seus débitos com descontos e volte a ter crédito para comprar novamente!"
						},
						{
							variableName: "textConfirmaAcordo",
							fieldType: "TextAreaField",
							label: "Texto de confirmação de acordo",
							type: "text",
							cols: "12",
							valueField: parceiro?.sessoes?.customization?.campos?.myDebits.detailsMonthlyPayment && parceiro.sessoes.customization.campos.myDebits.detailsMonthlyPayment.textConfirmaAcordo ? parceiro.sessoes.customization.campos.myDebits.detailsMonthlyPayment.textConfirmaAcordo : "Ao clicar em ‘Confirmar Acordo’ o cliente CONCORDA com os valores, datas e forma de pagamento apresentados bem como, com as regras de negociação do Credor. O Portal AcerteAqui envia diariamente informações de pagamento das parcelas ao Credor, para que o mesmo cumpra com as determinações legais junto aos órgãos de proteção ao crédito."
						},
						{
							variableName: "flgAcessoCredor",
							fieldType: "ToggleToken",
							label: "Acesso Credor",
							type: "text",
							cols: "6",
							valueField: parceiro?.sessoes?.customization?.campos?.landPage?.flgAcessoCredor
						},
						{
							variableName: "flgAgruparContratos",
							fieldType: "ToggleToken",
							label: "Agrupar Boletos",
							type: "text",
							cols: "6",
							valueField: parceiro?.sessoes?.customization?.campos?.myDebits?.flgAgruparContratos
						},
						{
							variableName: "flgValorOriginal",
							fieldType: "ToggleToken",
							label: "Valor Original",
							type: "text",
							cols: "6",
							valueField: parceiro?.sessoes?.customization?.campos?.myDebits?.flgValorOriginal
						},
						{
							variableName: "flgValidarDataNasc",
							fieldType: "ToggleToken",
							label: "Validar Data de Nascimento",
							type: "text",
							cols: "6",
							valueField: parceiro?.sessoes?.customization?.campos?.confirmBirthday?.flgValidarDataNasc
						},
						{
							variableName: "flgValidarTelefone",
							fieldType: "ToggleToken",
							label: "Validar Telefone",
							type: "text",
							cols: "6",
							valueField: parceiro?.sessoes?.customization?.campos?.confirmBirthday?.flgValidarTelefone
						},
						{
							variableName: "flgTermoCofissao",
							fieldType: "ToggleToken",
							label: "Termo Cofissão",
							type: "text",
							cols: "6",
							valueField: parceiro?.sessoes?.customization?.campos?.myAgreements?.flgTermoCofissao
						},
						{
							variableName: "flgSafrapay",
							fieldType: "ToggleToken",
							label: "Usa Safrapay",
							type: "text",
							cols: "6",
							valueField: parceiro?.sessoes?.customization?.campos?.myDebits?.flgSafrapay
						}
					];
					this.SET_LOADING(false);
				} else {
					this.SET_LOADING(false);
					this.$router.push({ name: "ListPartners" });
				}
			});
		} else {
			this.SET_LOADING(false);
			this.$router.push({ name: "ListPartners" });
		}
	},
	methods: {
		...mapMutations(["SET_LOADING", "CHANGE_MESSAGE_SNACKBAR", "CHANGE_MESSAGE_MODAL"]),
		...mapActions(["action_buscar_parceiro", "action_editar_parceiro", "action_buscar_empresas"]),
		async completeRegister() {
			let { nomeParceiro, hotjarId, subdominio, emp_codigo, logo, logoForBackgroundWhite, corPrimaria, corSecundaria, imagemFundo, tituloCabecalho, subtituloCabecalho, tituloSobre, imagemSobre, textoSobre, logosParceiros, textoParceiros, imagemFundoContato, whatsapp, telefone, phoneZeroEightHundred, email, facebook, instagram, endereco, whatsappOmni, instagramOmni, telegram, messenger, usu_skype, linkedin, telefoneOmni, emailOmni, imagemTutorial, tituloTutorial, FirstTutorialTitle, FirstTutorialSubtitle, SecondTutorialTitle, SecondTutorialSubtitle, ThirdTutorialTitle, ThirdTutorialSubtitle, FourthTutorialTitle, FourthTutorialSubtitle, textAbaixoLogo, textConfirmaAcordo, flgAcessoCredor, flgAgruparContratos, flgValorOriginal, flgValidarDataNasc, flgValidarTelefone, flgTermoCofissao, flgSafrapay } = this.inputsValues;

			if (!nomeParceiro || nomeParceiro.length === 0) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Atenção",
					message: `O campo nome do parceiro é obrigatório`,
					styleMessage: "danger"
				});
			} else if (!subdominio || subdominio.length === 0) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Atenção",
					message: `O campo nome do subdomínio é obrigatório`,
					styleMessage: "danger"
				});
			} else if (!logo || logo.length === 0) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Atenção",
					message: `O campo do logotipo do parceiro é obrigatório`,
					styleMessage: "danger"
				});
			} else if (!corPrimaria || corPrimaria.length === 0) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Atenção",
					message: `O campo cor primária é obrigatório`,
					styleMessage: "danger"
				});
			} else if (!corSecundaria || corSecundaria.length === 0) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Atenção",
					message: `O campo cor sercundária é obrigatório`,
					styleMessage: "danger"
				});
			} else if ((imagemSobre && imagemSobre?.base64 && !tituloSobre.length > 0 && textoSobre.length > 0) || (imagemSobre && imagemSobre?.base64 && tituloSobre.length > 0 && !textoSobre.length > 0) || (!imagemSobre && tituloSobre.length > 0 && textoSobre.length > 0) || (!imagemSobre && !tituloSobre.length > 0 && textoSobre.length > 0) || (!imagemSobre && tituloSobre.length > 0 && !textoSobre.length > 0) || (imagemSobre && !tituloSobre.length > 0 && !textoSobre.length > 0)) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Atenção",
					message: `Para registar o Sobre deve ser inserido a imagem da empresa, o título e o texo do sobre.`,
					styleMessage: "danger"
				});
			} else if ((imagemTutorial && imagemTutorial?.base64 && !tituloTutorial) || (!imagemTutorial && tituloTutorial)) {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Atenção",
					message: `Para registar o Passo a Passo deve ser inserido a imagem de fundo e o título do passo a passo.`,
					styleMessage: "danger"
				});
			} else {
				this.SET_LOADING(true);
				let header = null;
				let about = null;
				let tutorial = null;
				let partners = null;
				let contact = null;
				let omniChannel = null;
				let customization = null;

				if ((imagemFundo && imagemFundo?.base64) || subtituloCabecalho || tituloCabecalho) {
					header = {
						images: imagemFundo?.base64
							? [
									{
										identificador: 1,
										tipoImagem: imagemFundo.format,
										arquivo: imagemFundo.base64,
										adicionais: {
											name: imagemFundo.name
										}
									}
							  ]
							: [],
						background: 1,
						title: tituloCabecalho || null,
						subtitle: subtituloCabecalho || null
					};
				}

				if (imagemSobre && imagemSobre?.base64 && tituloSobre.length > 0 && textoSobre.length > 0) {
					about = {
						title: tituloSobre || null,
						text: textoSobre || null,
						image: 1,
						images: imagemSobre?.base64
							? [
									{
										identificador: 1,
										tipoImagem: imagemSobre.format,
										arquivo: imagemSobre.base64
									}
							  ]
							: []
					};
				}

				if (imagemTutorial && imagemTutorial?.base64 && tituloTutorial) {
					tutorial = {
						title: tituloTutorial,
						steps: [
							{ code: 0, title: FirstTutorialTitle, text: FirstTutorialSubtitle },
							{ code: 1, title: SecondTutorialTitle, text: SecondTutorialSubtitle },
							{ code: 2, title: ThirdTutorialTitle, text: ThirdTutorialSubtitle },
							{ code: 3, title: FourthTutorialTitle, text: FourthTutorialSubtitle }
						],
						images: imagemTutorial?.base64
							? [
									{
										identificador: 1,
										tipoImagem: imagemTutorial.format,
										arquivo: imagemTutorial.base64
									}
							  ]
							: []
					};
				}

				if (textoParceiros || logosParceiros) {
					partners = {
						text: textoParceiros || null,
						images: logosParceiros || null
					};
				}

				if (imagemFundoContato?.base64 || whatsapp || telefone || email || facebook || instagram || endereco || phoneZeroEightHundred) {
					contact = {
						phone: telefone,
						phoneZeroEightHundred: phoneZeroEightHundred,
						whatsapp: whatsapp,
						email: email,
						address: endereco,
						url_facebook: facebook,
						url_instagram: instagram,
						image: 1,
						images: imagemFundoContato?.base64
							? [
									{
										identificador: 1,
										tipoImagem: imagemFundoContato.format,
										arquivo: imagemFundoContato.base64
									}
							  ]
							: []
					};
				}

				if (whatsappOmni || instagramOmni || telegram || messenger || usu_skype || linkedin || telefoneOmni || emailOmni) {
					omniChannel = {
						whatsappOmni: whatsappOmni,
						instagramOmni: instagramOmni,
						telegram: telegram,
						messenger: messenger,
						usu_skype: usu_skype,
						linkedin: linkedin,
						telefoneOmni: telefoneOmni,
						emailOmni: emailOmni
					};
				}

				customization = {
					myDebits: {
						flgValorOriginal: flgValorOriginal,
						flgAgruparContratos: flgAgruparContratos,
						detailsMonthlyPayment: {
							textConfirmaAcordo: textConfirmaAcordo
						},
						flgSafrapay: flgSafrapay
					},
					myAgreements: {
						flgTermoCofissao: flgTermoCofissao
					},
					confirmBirthday: {
						flgValidarDataNasc: flgValidarDataNasc,
						flgValidarTelefone: flgValidarTelefone
					},
					menuDebits: {
						textAbaixoLogo: textAbaixoLogo
					},
					landPage: {
						flgAcessoCredor: flgAcessoCredor
					}
				};

				let obj = {
					estilo: {
						corPrimaria: corPrimaria,
						corSecundaria: corSecundaria
					},
					nome: nomeParceiro,
					logo: logo.base64,
					identificador: subdominio,
					emp_codigo: emp_codigo,
					hotjar_id: hotjarId,
					tipoLogo: logo.format,
					sessoes: {
						logoForBackgroundWhite: logoForBackgroundWhite.base64,
						header: header,
						about: about,
						partners: partners,
						contact: contact,
						tutorial: tutorial,
						customization: customization,
						omniChannel: omniChannel
					}
				};

				this.action_editar_parceiro({ ...obj, id: this.$route.params.id })
					.then((response) => {
						if (response) {
							this.$router.push({ name: "ListPartners" });
							this.CHANGE_MESSAGE_SNACKBAR("Parceiro atualizado com sucesso!");
							setTimeout(() => this.CHANGE_MESSAGE_SNACKBAR(""), 5000);
							this.SET_LOADING(false);
						} else {
							this.SET_LOADING(false);
							this.CHANGE_MESSAGE_MODAL({
								show: true,
								title: "Ocorreu um erro",
								message: `Não foi possivel atualizar este parceiro`,
								styleMessage: "danger"
							});
						}
					})
					.catch((error) => {
						this.SET_LOADING(false);
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Ocorreu um erro",
							message: `Não foi possivel atualizar este parceiro`,
							styleMessage: "danger"
						});
					});
			}
		}
	}
};
</script>

<style scoped></style>
